const COMPRESSION_LEVEL = {
	// Already-compressed formats — store verbatim (level 0)
	pdf: 0, jpg: 0, jpeg: 0, png: 0, gif: 0, webp: 0, heic: 0, heif: 0,
	docx: 0, xlsx: 0, pptx: 0,          // Office Open XML = ZIP containers
	zip: 0, gz: 0, rar: 0, '7z': 0,
	mp4: 0, mov: 0, mp3: 0, aac: 0,

	// Compressible text formats — level 4 (good ratio, reasonable CPU)
	csv: 4, tsv: 4, txt: 4,
	xml: 4, json: 4, svg: 4,
	html: 4, htm: 4, md: 4, rtf: 4,

	// Conditionally compressible binary formats
	bmp: 4, tif: 4, tiff: 4,
};

/**
 * Returns the fflate compression level (0–9) for the given filename.
 * Level 0 = store (no compression). Level 4 = fast + good ratio.
 * Unknown extensions default to level 1 (fast pass, catches any compressible content).
 */
export function compressionLevel(filename) {
	const ext = (filename.split('.').pop() ?? '').toLowerCase();
	return COMPRESSION_LEVEL[ext] ?? 1;
}
